import _ from 'lodash';
import { getStringFromArray } from '../../../utils';

const answers = {
  perHour:
    '(a) <u>Fee.</u><br /> ' +
    '<br />A non-recoupable, <HOURLY_FEE> in the amount of ' +
    '$<AMOUNT> per hour for Producer’s time as reserved by ' +
    'Owner and for all services rendered by Producer hereunder and ' +
    '(collectively the “Fee”), <PAY SCHEDULE>',
  flatFee:
    '(a) <u>Fee.</u><br /> ' +
    '<br />A non-recoupable, <HOURLY_FEE> in the amount of ' +
    '$<AMOUNT>, <PAY SCHEDULE>',
  execution:
    'payable within <DAYS> days following the execution of this agreement.',
  completion:
    'payable within <DAYS> days following Producer’s provision of such services',
  multipleSchedule:
    'payable as follows: (i) ' +
    '$<AMOUNT1> following commencement of production of the Master(s); and (ii) the balance, ' +
    '$<AMOUNT2>, promptly following Producer’s delivery to Owner of the mixed and commercially satisfactory Master(s).',
  receipts:
    '<br />(b) <u>Net Receipts.</u><br /> ' +
    '<br />(i) In addition to the <ADDITIONAL_SENTENCE>, Producer shall receive: (i) <PERCENTAGE>% of Owner’s Net Receipts earned by or credited to Owner in connection with any and all ' +
    '<ROYALTY_STREAM_SELECT> of the Master(s).  “Net Receipts” shall mean Owner’s gross receipts received in connection with the Master(s), ' +
    'less all documented costs and expenses actually incurred by Owner in connection with the recording of the Master(s) ' +
    'and the cost (prorated in the event there are other master recordings on the particular record concerned) of manufacturing, distribution, and union payments incurred in connection with the records upon which the Master(s) appear.<br /> ' +
    '<br />(ii)	As to records embodying the Master(s) but not consisting entirely of the Master(s), ' +
    'the royalties and sums otherwise payable to Producer as provided herein with respect to such sales shall be pro rated by multiplying the applicable royalty rate ' +
    'Producer is due by a fraction, the numerator of which is equal to the number of times the Master(s) are embodied on such record and the denominator of which is the total number of master recordings embodied thereon, including the Master(s).',
  calculation:
    '<br />(c) <u>Calculation and Accounting.</u><br /> ' +
    '<br />Statements as to Royalties or other sums payable hereunder shall be sent by ' +
    'Owner to Producer at the address above within ' +
    '<DAYS> days after the expiration of each ' +
    '<PERIOD> calendar period.  Concurrently with the rendition of each statement, ' +
    'Owner shall pay Producer all Royalties and other sums shown to be due by such statement by money order, cash, check, or other method agreed to by the parties.',
  advance:
    '(a) <u>Advance.</u><br /> ' +
    '<br />(i) An advance against Producer’s share of Net Receipts in the amount of ' +
    '$<AMOUNT> (the “Advance”) per Master, which amount shall be deemed an advance against and recoupable from any and all royalties (excluding mechanical royalties, ' +
    'if applicable) payable to Producer hereunder.  The advance shall be <PAY SCHEDULE>',
  audit:
    '<br />(d) <u>Audit.</u><br /> ' +
    '<br />Producer may audit Owner’s books and records pertaining to the payment of Royalties to Producer hereunder upon reasonable prior notice.',
};

export default (options) => {
  let content = '';
  let schedule = '';
  let joinReceipts = '';
  let receiptsContent = answers['receipts'];
  let calculationContent = answers['calculation'];
  let auditContent = answers['audit'];
  let checked = false;
  const ownershipOptions = options.ownershipBlock
    ? options.dealType === 'edit'
      ? options.ownershipBlock.changes
      : options.ownershipBlock.options
    : null;

  if (
    options.paidType === 0 ||
    options.paidType === 1 ||
    options.paidType === 2
  ) {
    if (options.paidType === 2) {
      content = answers['advance'];
    } else {
      content = answers[options.feeType] || '';
    }
    content = content.replace(
      '<HOURLY_FEE>',
      options.feeType === 'perHour' ? 'hourly fee' : 'fee'
    );

    content = content.replace(
      '<AMOUNT>',
      options.amount
        ? parseFloat(options.amount)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : ''
    );

    if (options.paySchedule === 1) {
      schedule = answers['multipleSchedule'];
      schedule = schedule.replace(
        '<AMOUNT1>',
        options.amount1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      );
      schedule = schedule.replace(
        '<AMOUNT2>',
        options.amount2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      );
    } else if (options.paySchedule === 0) {
      schedule = answers[options.scheduleType] || '';
      schedule = schedule.replace('<DAYS>', options.day);
    }
    content = content.replace('<PAY SCHEDULE>', schedule);
  }
  if (options.paidType === 1 || options.paidType === 2) {
    joinReceipts = getStringFromArray('payments', options);

    receiptsContent = receiptsContent.replace(
      '<PERCENTAGE>',
      options.percentage
    );
    receiptsContent = receiptsContent.replace(
      '<ROYALTY_STREAM_SELECT>',
      joinReceipts
    );
    content += (content === '' ? '' : '<br />') + receiptsContent;

    if (options.paidType === 1) {
      content = content.replace('<ADDITIONAL_SENTENCE>', 'Fee');
    } else if (options.paidType === 2) {
      content = content.replace('<ADDITIONAL_SENTENCE>', 'Advance');
    }

    if (options.period) {
      calculationContent = calculationContent.replace(
        '<PERIOD>',
        options.period
      );
    }
    if (options.periodDay) {
      calculationContent = calculationContent.replace(
        '<DAYS>',
        options.periodDay
      );
    }
    content += '<br />' + calculationContent;

    if (options.auditType === 'will') {
      content += '<br />' + auditContent;
    }
  }

  if (ownershipOptions) {
    let tagNumber = '';
    if (options.paidType === undefined) {
      tagNumber = '(a)';
    }
    if (options.paidType === 0) {
      tagNumber = '(b)';
      if (options.feeType === undefined) {
        tagNumber = '(a)';
      }
    } else if (options.paidType === 1) {
      tagNumber = '(e)';
      if (options.feeType === undefined) {
        tagNumber = '(a)';
      }
      if (options.auditType === undefined || options.auditType === 'notWill') {
        tagNumber = '(d)';
      }
    } else {
      tagNumber = '(e)';
      if (options.auditType === undefined || options.auditType === 'notWill') {
        tagNumber = '(d)';
      }
    }

    if (ownershipOptions.composition === 0) {
      if (options.paidType !== undefined) {
        content +=
          '<OWNERSHIP_OPTION><br /><br />' +
          `${tagNumber} <u>Compositions.</u><br />` +
          'Producer warrants and represents that Producer has not made nor will make any contributions to the authorship of the Composition(s) or other materials recorded hereunder and shall not claim any right, title or interest therein.';
      } else {
        content +=
          '<OWNERSHIP_OPTION><br /><br />' +
          `(a) <u>Compositions.</u><br />` +
          'Producer warrants and represents that Producer has not made nor will make any contributions to the authorship of the Composition(s) or other materials recorded hereunder and shall not claim any right, title or interest therein.';
      }
    } else if (ownershipOptions.composition === 1) {
      if (options.paidType !== undefined) {
        content +=
          '<OWNERSHIP_OPTION><br /><br />' +
          `${tagNumber} <u>Publishing/Mechanical.</u><br />` +
          'That portion of any Composition(s) written or co-written by the Producer hereunder is hereby and shall be licensed to Owner ' +
          `at ${options['statutoryPercentage']}% of the then current minimum statutory rate, subject to the accounting terms set forth in paragraph 2 above.  Owner and Producer acknowledge and agree that the percentages listed in Schedule B accurately set forth Producer’s share of all right, title and interest, including copyright, in and to the Composition(s).`;
      } else {
        content +=
          '<OWNERSHIP_OPTION><br /><br />' +
          `(a) <u>Publishing/Mechanical.</u><br />` +
          'That portion of any Composition(s) written or co-written by the Producer hereunder is hereby and shall be licensed to Owner ' +
          `at ${options['statutoryPercentage']}% of the then current minimum statutory rate, subject to the accounting terms set forth in paragraph 2 above.  Owner and Producer acknowledge and agree that the percentages listed in Schedule B accurately set forth Producer’s share of all right, title and interest, including copyright, in and to the Composition(s).`;
      }
    }
  }

  if (
    options.amount !== '' &&
    (options.paySchedule === 0 || options.paySchedule === 1) &&
    ((options.scheduleType && options.day !== '') ||
      (options.amount1 !== '' && options.amount2 !== ''))
  ) {
    if (options.paidType === 0 && options.feeType) {
      checked = true;
    }
    if (options.paidType === 1 && options.feeType) {
      if (
        options.percentage !== '' &&
        (options.sales ||
          options.performances ||
          options.licenses ||
          options.any) &&
        options.period &&
        options.periodDay &&
        options.auditType
      ) {
        checked = true;
      }
    }
    if (options.paidType === 2) {
      if (
        options.percentage !== '' &&
        (options.sales ||
          options.performances ||
          options.licenses ||
          options.any) &&
        options.period &&
        options.periodDay &&
        options.auditType
      ) {
        checked = true;
      }
    }
  }

  if (
    checked === true &&
    ownershipOptions &&
    ownershipOptions.composition === 1
  ) {
    if (options.statutoryPercentage !== '') {
      checked = true;
    } else {
      checked = false;
    }
  }

  return {
    content,
    checked,
  };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Payments.js